import authRoles from 'app/auth/authRoles';
import { FuseLoadable } from '@fuse';

export const Manifest = { auth: authRoles.processor, routes: [{ path: '/manifest/:id?', component: FuseLoadable({ loader: () => import('./ManifestApp') }) }] };

export const ManifestSearch = { auth: authRoles.processor, routes: [{ path: '/manifest-search', component: FuseLoadable({ loader: () => import('./ManifestSearchApp') }) }] };

export default [Manifest, ManifestSearch];
